<template>
  <div
    class="as-incident-list as-footStats as-d-flex as-flex-column"
    :class="{
      'as-scrolling as-scrolling__result-popup': !isHomePage,
      'as-home-scrollable-content': isHomePage,
      'as-incident-list-sm': screenWidth < 375,
    }"
  >
    <div class="as-incident-list__content" v-if="goals">
      <div class="as-incident-list__content-data">
        <IncidentsItem
          :goal="goal"
          :modeTeam="goal?.team"
          v-for="(goal, index) in goals"
          :key="index"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, defineProps, PropType, inject, ref, watchEffect, onMounted } from "vue";
import type { IMatch } from "~src/interfaces";
import IBall from "~src/components/icons/incident/IBall.vue";
import IncidentsItem from "./IncidentsItem.vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import type { IGoalDetails, IPlayer, ITeam } from "~src/interfaces/footystats";
import { getPlayerLists } from "~src/services/FootystatsService";
const matchDetailStore = useMatchDetailStore();

interface IProps {
  isHomePage?: boolean;
  goalDetails: IGoalDetails[];
  players: IPlayer[];
}
const screenWidth = computed(() => matchDetailStore.getScreenWidth);
const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
});

const goals = ref<IGoalDetails[]>(props.goalDetails || []);
// const players = ref<IPlayer[]>([]);

onMounted(async () => {
  if (props.goalDetails) {
    const players = props.players ?? [];
    goals.value = props.goalDetails.map((goal: IGoalDetails) => {
      let player = players.find((p: IPlayer) => p.id === goal.player_id);
      return {
        ...goal,
        player
      };
    });
  }
});


</script>
<script lang="ts">
export default {};
</script>
